export function PaperclipIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}> 
      <path d="M17.6271 9.08284L10.1141 16.5958C8.40556 18.3044 5.63546 18.3044 3.92692 16.5958C2.21837 14.8873 2.21837 12.1172 3.92692 10.4087L11.4399 2.89565C12.579 1.75662 14.4257 1.75662 15.5647 2.89565C16.7037 4.03468 16.7037 5.88141 15.5647 7.02044L8.34633 14.2388C7.77682 14.8083 6.85345 14.8083 6.28394 14.2388C5.71442 13.6693 5.71442 12.7459 6.28394 12.1764L12.6184 5.84193" stroke="#101828" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

PaperclipIcon.displayName = 'PaperclipIcon';
